const TZ = 'Asia/Tokyo'

type DateLike = string | number | Date | null | undefined

/**
 * タイムゾーン情報のない文字列をUTCとして正しくパースする。
 * SQLite CURRENT_TIMESTAMP は "YYYY-MM-DD HH:MM:SS" (UTC) を返すが、
 * ブラウザの new Date() はこれをローカル時刻として解釈してしまうため、
 * 明示的に 'Z' (UTC) を付与して正しく変換する。
 */
function toDate(v: NonNullable<DateLike>): Date {
  if (typeof v === 'string') {
    // "YYYY-MM-DD HH:MM:SS" (SQLite CURRENT_TIMESTAMP) → UTC として扱う
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(v)) {
      return new Date(v.replace(' ', 'T') + 'Z')
    }
    // "YYYY-MM-DDTHH:MM:SS" (タイムゾーンなしISO) → UTC として扱う
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(v)) {
      return new Date(v + 'Z')
    }
  }
  return new Date(v)
}

/** 2025/2/23 14:30:05 */
export function formatDateTime(v: DateLike): string {
  if (v == null) return ''
  return toDate(v).toLocaleString('ja-JP', { timeZone: TZ, hour12: false })
}

/** 2025/02/23 */
export function formatDate(v: DateLike): string {
  if (v == null) return ''
  return toDate(v).toLocaleDateString('ja-JP', { timeZone: TZ })
}

/** 14:30:05 */
export function formatTime(v: DateLike): string {
  if (v == null) return ''
  return toDate(v).toLocaleTimeString('ja-JP', { timeZone: TZ, hour12: false })
}

/** 14:30 */
export function formatTimeShort(v: DateLike): string {
  if (v == null) return ''
  return toDate(v).toLocaleTimeString('ja-JP', {
    timeZone: TZ,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

/** 相対時間表示 ("5m ago", "2h ago" 等) */
export function timeAgo(v: DateLike): string {
  if (v == null) return ''
  const diff = Date.now() - toDate(v).getTime()
  const mins = Math.floor(diff / 60_000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  return `${days}d ago`
}
